import { ArrowLeft } from 'lucide-react';
import React from 'react';
import type { Application } from '../types/application.types';

interface ApplicationReviewHeaderProps {
  application: Application;
  onBack: () => void;
}

export const ApplicationReviewHeader: React.FC<ApplicationReviewHeaderProps> = ({ application, onBack }) => {
  console.log('[ApplicationReviewHeader] Rendering header for:', application.reference);

  const statusConfig = getStatusConfig(application.status);

  return (
    <div className="mb-6 flex items-center gap-4">
      <button
        onClick={onBack}
        className="flex items-center justify-center w-10 h-10 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 hover:text-slate-900 transition-colors focus:outline-none focus:ring-2 focus:ring-[#00758d] focus:ring-offset-2"
        aria-label="Retour à la liste"
      >
        <ArrowLeft size={20} />
      </button>

      <div className="flex-1">
        <div className="flex items-center gap-3 mb-1">
          <h1 className="text-2xl font-semibold text-slate-900">Dossier {application.reference}</h1>
          <span
            className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold"
            style={{
              backgroundColor: statusConfig.bg,
              color: statusConfig.text,
            }}
          >
            {statusConfig.label}
          </span>
        </div>
        <p className="text-sm text-slate-600">{application.customerName || application.companyName || 'Client'}</p>
      </div>
    </div>
  );
};

function getStatusConfig(status: string): { label: string; bg: string; text: string } {
  // Couleurs SING : Turquoise #00758d, Jaune #dfc32f, Magenta #a4006c, Marron #5c4738
  const configs: Record<string, { label: string; bg: string; text: string }> = {
    PENDING: { label: 'En attente', bg: 'rgba(223, 195, 47, 0.15)', text: '#dfc32f' }, // Jaune SING
    APPROVED: { label: 'Approuvé', bg: 'rgba(0, 117, 141, 0.15)', text: '#00758d' }, // Turquoise SING
    CONFIRMED: { label: 'En cours', bg: 'rgba(0, 117, 141, 0.15)', text: '#00758d' }, // Turquoise SING
    PAID: { label: 'Payé', bg: 'rgba(0, 117, 141, 0.15)', text: '#00758d' }, // Turquoise SING
    COMPLETED: { label: 'Clôturé', bg: 'rgba(0, 117, 141, 0.15)', text: '#00758d' }, // Turquoise SING
    REJECTED: { label: 'Refusé', bg: 'rgba(92, 71, 56, 0.15)', text: '#5c4738' }, // Marron SING
    CANCELLED: { label: 'Annulé', bg: 'rgba(92, 71, 56, 0.15)', text: '#5c4738' }, // Marron SING
    AWAITING_PAYMENT: { label: 'En attente de paiement', bg: 'rgba(223, 195, 47, 0.15)', text: '#dfc32f' }, // Jaune SING
  };

  return configs[status] || { label: status, bg: 'rgba(0, 117, 141, 0.15)', text: '#00758d' };
}
